/**
 * FloorPlanConfig — registry entry (Component only; completeness is registered
 * separately in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { FloorPlanConfig } from './FloorPlanConfig.component'

export const floorPlanConfigModule: PfConfigModule = {
  flowId: 'floor_plan_config',
  Component: FloorPlanConfig,
}
